import React, { useEffect } from 'react';
import { Button, Navbar, NavbarBrand } from 'reactstrap';
import Router from 'next/router';

import { PATH_LOGO } from 'constants/constants';
import { useDispatch, useSelector } from 'react-redux';
import { getMetaDataAsync } from 'store/settingAccount';
import { getColor, getColorText, getColorThemeAsync } from 'store/settings';
import styled from '@emotion/styled';

const Header = () => {
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const dispatch = useDispatch();
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
      border-color: ${colorStatus} !important;
    }
  `;
  useEffect(() => {
    dispatch(getMetaDataAsync());
    dispatch(getColorThemeAsync());
  }, []);
  return (
    <header className="header">
      <div className="container-xl px-0">
        <Navbar light expand="lg" className="d-flex justify-content-between">
          <NavbarBrand onClick={() => Router.push('/home')}>
            {(metaData?.logo && metaData?.logo[320]) || metaData?.logo?.root ? (
              <img
                src={
                  (metaData?.logo && metaData?.logo[320]) ||
                  metaData?.logo?.root
                }
                className="header__logo"
                alt="logo"
              />
            ) : (
              <div className="header__logo" />
            )}
          </NavbarBrand>
          <Stylescal>
            <Button
              className="btn round"
              color="danger"
              onClick={() => Router.push('/login')}
            >
              Login
            </Button>
          </Stylescal>
        </Navbar>
      </div>
    </header>
  );
};

export default Header;
